/**
 * @info
 *
 * *The "store/global" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind global functionality.
 *
 * *This file*
 * This file outlines "state". This is the starting snapshot
 * of the modules underlying state. As the user interacts with
 * the components tied into this Vuex module, this state is modified
 * away from these default values.
 */

import { categorySwatchOptionMarkup } from 'utils/general'

export default () => {
  return {
    loading: false,
    product: {},
    microCollectionProducts: [],
    activeCategory: {
      label: categorySwatchOptionMarkup('all', 'All Shades'),
      value: 'all'
    },
    modalTitle: '',
    ctaText: '',
    action: '',
    itemToUpdate: false,
    isGWP: false,
    selectedVariant: null
  }
}
